// extracted by mini-css-extract-plugin
export default {"modal":"auto-play-modal_modal__RQ6gK","mobile":"auto-play-modal_mobile__0fTKs"};